import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import "../../Assets/CSS/SuccessModal.scss";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
const SuccessModal = ({ show, handleClose, title, message, isError }) => {

  // ✅ Auto close after 4 seconds
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        handleClose();
      }, 15000);

      return () => clearTimeout(timer);
    }
  }, [show, handleClose]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      contentClassName={`modern-modal fade-in ${isError ? "error" : "success"}`}
    >
      <div className="modal-container">
        {/* Close Button */}
        <button className="close-btn" onClick={handleClose}>
          <X size={16} />
        </button>

        {/* Curved Top Section */}
        <div className="modal-top">
          <div className="glow-circle"></div>
          <div className="lottie-wrapper">
            <DotLottieReact
              src={
                isError
                  ? "https://lottie.host/2f0f9f3d-6f7a-4c3b-bf1b-3e40bba0e7ed/error.lottie"
                  : "https://lottie.host/d8b44460-a833-4ec1-8dfd-1b5bf51b93c6/QAIgmqqFBk.lottie"
              }
              loop
              autoplay
            />
          </div>
        </div>

        {/* Bottom Content */}
        <div className="modal-content-section">
          <h3>{title}</h3>
          <p>{message}</p>
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
